import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import bankdetails from '../../assets/img/Bank-details.jpg';
import { Button, Form } from 'react-bootstrap';
import { getBankAccountDetails, updateBankAccountDetails } from '../../Redux/BankAccountDetails/action';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ToasterMessage from '../ToasterMessage';
import loader from '../../assets/img/loader.gif';


const BankAccountDetails = () => {

    const [bankaccountdetails, setBankdaccountdetails] = useState({})
    const [toaster, setToaster] = useState("");
    const [isloader, setIsloader] = useState(false);


    useEffect(() => {
        getBankAccountDetails()((response) => {
            if (response && response.status) {
                setBankdaccountdetails(response?.data)
                formik.setValues({
                    ...formik.values,
                    accountname: response?.data[0]?.account_name,
                    ifsccode: response?.data[0]?.ifsc_code,
                    accountnumber: response?.data[0]?.account_number,
                })
            }
        });
    }, []);
    const validationSchema = Yup.object().shape({
        accountname: Yup.string().matches(/^[a-zA-Z0-9 ]+$/, 'Enter a valid Account Name')
            .required('Required'),
        ifsccode: Yup.string().matches(/^[a-zA-Z0-9 ]+$/, 'Enter a valid IFSC Code')
            .required('Required'),
        accountnumber: Yup.string().matches(/^[a-zA-Z0-9 ]+$/, 'Enter a valid Account Number')
            .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            accountname: "",
            ifsccode: "",
            accountnumber: "",
        },
        validationSchema,
        onSubmit: (values) => {
            setIsloader(true)
            let formData = new FormData();
            formData.append("account_name", values.accountname);
            formData.append("ifsc_code", values.ifsccode);
            formData.append("account_number", values.accountnumber);
            updateBankAccountDetails({ formData })((response) => {
                if (response && response.status) {
                }
                setIsloader(false)
                setToaster("Save Changes")
                setTimeout(() => {
                    setToaster("")

                }, 2000);
            });
        },
    });
    return (
        <React.Fragment>
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Add Bank Account Details </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Add Bank Account Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <img src={bankdetails} alt='' className='img-fluid' />
                        </div>
                        <div className='col-lg-6'>
                            <div className="bank-details">
                                <Form onSubmit={formik.handleSubmit}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Account Name <span>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="accountname"
                                            value={formik.values?.accountname}
                                            onChange={formik.handleChange}
                                            isValid={formik.touched.accountname && !formik.errors.accountname}
                                            isInvalid={!!formik.errors.accountname}
                                            maxLength={30}
                                            placeholder="Enter Account Name"
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.accountname}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>IFSC Code <span>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="ifsccode"
                                            value={formik.values?.ifsccode}
                                            onChange={formik.handleChange}
                                            isValid={formik.touched.ifsccode && !formik.errors.ifsccode}
                                            isInvalid={!!formik.errors.ifsccode}
                                            maxLength={15}
                                            placeholder="Enter IFSC Code"
                                            style={{ textTransform: "uppercase" }}
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.ifsccode}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>Account Number <span>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="accountnumber"
                                            value={formik.values?.accountnumber}
                                            onChange={formik.handleChange}
                                            isValid={formik.touched.accountnumber && !formik.errors.accountnumber}
                                            isInvalid={!!formik.errors.accountnumber}
                                            maxLength={30}
                                            placeholder="Enter Account Number"
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.accountnumber}</Form.Control.Feedback>
                                    </Form.Group>

                                    <div className='bank-details-btn mt-4'>
                                        {isloader == true ?
                                            <div className='loader'>
                                                <img src={loader} alt="" className='img-fluid' />
                                            </div>
                                            :
                                            <button type="submit" className="btn btn-primary" >Save</button>
                                        }
                                    </div>

                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default BankAccountDetails;